module.exports = __webpack_public_path__ + "img/Menu-04.0ad9e4d9.png";